import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    PartialSalaryGroupDto, PartialSalaryGroupPaginator,
    CreatePartialSalaryGroupDto,
    QueryPartialSalaryGroupDto,
    SearchPartialSalaryGroupDto,
    UpdatePartialSalaryGroupDto
} from "../models/partial-salary-group.dto";
import ENDPOINTS from "./utils/endpoints";
import {QueryOptionsDto} from "../models/generic.dto";

export function useGetPartialSalaryGroup(companyId: number, options?: QueryPartialSalaryGroupDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.PARTIALSALARYGROUP.GET;
    const request = (options: QueryPartialSalaryGroupDto) => API.ProcessingCompanyAPI.getPartialSalaryGroups(companyId,options);

    const { data, isLoading, error, refetch } = useQuery<PartialSalaryGroupPaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        {...API.Handlers.pageParamOption}
    );

    return { data, isLoading, error, refetch }
}

export function useGetPartialSalaryGroupSearch() {

    return useMutation(
        (companyId: number, options?: SearchPartialSalaryGroupDto) => API.ProcessingCompanyAPI.getPartialSalaryGroupSearch(companyId, options),
        {
            onSuccess: () => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useGetPartialSalaryGroupById(companyId: number, id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.PARTIALSALARYGROUP.DETAIL;
    const request = API.ProcessingCompanyAPI.getPartialSalaryGroupById(companyId,id);

    const {data, isLoading, error} = useQuery<{ data:PartialSalaryGroupDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreatePartialSalaryGroup() {
    const queryClient = useQueryClient();

    return useMutation(
        ({companyId, payload}: {companyId: number, payload: CreatePartialSalaryGroupDto}) => API.ProcessingCompanyAPI.createPartialSalaryGroup(companyId, payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.PARTIALSALARYGROUP.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdatePartialSalaryGroup() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, companyId, id}: {payload: UpdatePartialSalaryGroupDto, companyId: number, id: number}) => API.ProcessingCompanyAPI.updatePartialSalaryGroup(companyId, id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.PARTIALSALARYGROUP.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeletePartialSalaryGroup() {

    return useMutation(
        ({companyId, id}: {companyId: number, id: number}) => API.ProcessingCompanyAPI.deletePartialSalaryGroupById(companyId, id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}